<template>
  <component :is="driverData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="driverData === undefined">
      <h4 class="alert-heading">
        {{ $t('Error fetching driver data') }}
      </h4>
      <div class="alert-body">
        {{ $t('No driver found with this driver id. Check') }}
        <b-link class="alert-link" :to="{ name: 'drivers_index' }">
          {{ $t('Driver List') }}
        </b-link>
        {{ $t('for other drivers.') }}
      </div>
    </b-alert>


    <div class="loading_page" v-if="requestStatus">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
    </div>


    <b-tabs v-if="driverData" vertical content-class="col-12 col-md-9 mt-1 mt-md-0"
      nav-wrapper-class="col-md-2 col-12 border rounded p-1" nav-class="nav-left" pills>

      <info-tab :errors="errors" :driver-data="driverData" @onSubmit="submit" class="mt-2 pt-75" />

      <wasl-tab v-if="$store.state.auth.userData.roles.includes(this.$roles.SUPER_ADMIN)" :driver-data="driverData"
        :errors="errors" />

      <devices-tab v-if="driverData"  :data="driverData"></devices-tab>

    </b-tabs>
  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BButton,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import driverStoreModule from '@/views/modules/driver/driverStoreModule'

import { OrbitSpinner } from 'epic-spinners'
import InfoTab from '@/views/modules/driver/tabs/InfoTab'
import WaslTab from '@/views/modules/driver/tabs/WaslTab.vue'
import DevicesTab from '@/views/modules/driver/tabs/DevicesTab'
import Ripple from 'vue-ripple-directive'
export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BButton,
    BAlert,
    OrbitSpinner,
    InfoTab,
    WaslTab,
    DevicesTab,
    BLink,

  },
  directives: {
    Ripple,
  },
  setup(props, { root }) {

    const driverData = ref(null)

    const errors = ref({})

    const requestStatus = ref(true)

    const DRIVER_APP_STORE_MODULE_NAME = 'app_driver'

    if (!store.hasModule(DRIVER_APP_STORE_MODULE_NAME)) store.registerModule(DRIVER_APP_STORE_MODULE_NAME, driverStoreModule)

    onUnmounted(() => {
      if (store.hasModule(DRIVER_APP_STORE_MODULE_NAME)) store.unregisterModule(DRIVER_APP_STORE_MODULE_NAME)
    })

    const submit = () => {
      requestStatus.value = true
      errors.value = {}
      store.dispatch('app_driver/editDriver', driverData.value).then(res => {
        requestStatus.value = false
        toaster('Driver Updated successfully', 'success', 'success')
      }).catch(res => {
        errors.value = res.response.data.errors
      }).finally(() => {
        requestStatus.value = false
      })
    }

    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }

    store.dispatch('app_driver/fetchDriver', { id: router.currentRoute.params.id })
      .then(response => {
        driverData.value = response.data.driver
        requestStatus.value = false
      })
      .catch(error => {
        console.log(error)
      })

    return {
      driverData,
      requestStatus,
      errors,
      submit
    }
  },
}
</script>

<style></style>
